import { postSwitchCampaign } from '../services';
export const postActivateDeactivate = (params) => postSwitchCampaign(params).then(response => formattedData(response?.data));
const formattedData = (response) => {
    return response?.success;
};
